import React, { useState } from 'react';
import {
    Box,
    Stepper,
    Step,
    StepLabel,
    TextField,
    Button,
    Typography,
    Avatar
} from '@mui/material';
import homeIcon from "../../assets/home.png"; // adjust path if needed
import CloseIcon from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';

const Header = (props) => {
    return (
        <Box>
        <Box sx={{ width: '100%', fontFamily:'Cairo',direction: 'ltr', pt: 4, pl:4, pr:4,pb:2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <img src={homeIcon} />
                <Typography variant="h6" fontWeight="Bold" fontFamily={'Cairo'} >
                    تفاصيل طلب القطع
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="h6" fontWeight="Bold" fontFamily={'Cairo'} >1/5</Typography>
                <CloseIcon />
            </Box>
        </Box>
        <Box sx={{ width: '100%', }} color={"#782959"}>
              <LinearProgress variant="determinate" color="inherit"  value={props?.Step *20} />
            </Box>
        </Box>
    );
};

export default Header;
